const sortCodes = (codes, list, payload) => {
    let newCodes = [...codes];
    const payloadCodes = Object.entries(payload);
    for(let i = 0; i < payloadCodes.length; i++){
        for(let indexList = 0; indexList < newCodes.length; indexList++){
            if(payloadCodes[i][0] === newCodes[indexList].code && payloadCodes[i][0] !== "commissions"){                        
                const value = list[newCodes[indexList].type]?.find(accountingCode => accountingCode.id === payloadCodes[i][1]);
                
                //if doesn't exist (anymore), then just return the first value of the list if it exists;
                newCodes[indexList].value = !_.isUndefined(value) ? value : (list[newCodes[indexList].type][0] ?? null);
                break;
            }
        }
    }
    return newCodes;
}
const sortCodesVat = (codes, list, payload, vatType) => {
    let newCodes = [...codes];
    const payloadCodes = Object.entries(payload);
    //
    const defaultVatCode = vatType === 'collectionVat' ? list.vat.findIndex(vatCode => vatCode.code.match(/^445800$/)) : 0;

    for(let i = 0; i < payloadCodes.length; i++){
        for(let indexList = 0; indexList < newCodes.length; indexList++){
            if(payloadCodes[i][0] === newCodes[indexList].code && newCodes[indexList].type === vatType){   
                const value = list.vat?.find(accountingCode => accountingCode.id === payloadCodes[i][1]);
                
                // if doesnt exist (anymore), then just set the default value or null
                newCodes[indexList].value = !_.isUndefined(value) ? value : (list.vat[defaultVatCode] ?? null);
                break;
            }
        }
    }
    return newCodes;
}

const findAccountingCode = (state, code, type) =>{
    let value = 0;
    for(let i = 0; i < state.codes.length; i++){
        if(state.codes[i] && state.codes[i].code === code && state.codes[i].type === type){
            value = state.codes[i]?.value?.id ? state.codes[i].value.id : value;
            break;
        }
    }
    return value;
}

const persistAccountingChart = (state) => {
    const codeLength = (typeof state.codeLength === "string") ? parseInt(state.codeLength) : state.codeLength;
    return {
        "accounting_code_length": codeLength,
        "deposit_accounting_code": state.depositCode,
        "discount": {
            "enabled": state.discountEnable,
            "sell_discount_code_id": findAccountingCode(state, "sell_discount_code_id", "sell"),
            "purchase_discount_code_id": findAccountingCode(state, "purchase_discount_code_id", "purchase")
        },
        "default_codes": {
            "thirds":findAccountingCode(state, "thirds", "third"),
            "staffs": findAccountingCode(state, "staffs", "third"),
            "suppliers": findAccountingCode(state, "suppliers", "third"),
            "banks": findAccountingCode(state, "banks", "bank"),
            "pay_mediums": findAccountingCode(state, "pay_mediums", "bank"),
            "products_sales": findAccountingCode(state, "products_sales", "sell"),
            "services_sales": findAccountingCode(state, "services_sales", "sell"),
            "products_purchases": findAccountingCode(state, "products_purchases", "purchase"),
            "services_purchases": findAccountingCode(state, "services_purchases", "purchase"),
            "commissions": findAccountingCode(state, "commissions", "reconciliation"),
            "debit_vat": {
                "collected_vat": findAccountingCode(state, "collected_vat", "debitVat"),
                "deductible_vat": findAccountingCode(state, "deductible_vat", "debitVat")
            },
            "collection_vat": {
                "collected_vat": findAccountingCode(state, "collected_vat", "collectionVat"),
                "deductible_vat": findAccountingCode(state, "deductible_vat", "collectionVat")
            }
        }
    }
}

export {
    persistAccountingChart,
    sortCodes,
    sortCodesVat
}